import React from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import classNames from 'classnames';
import parse from 'date-fns/parse';
import format from 'date-fns/format';
import isAfter from 'date-fns/is_after';
import isBefore from 'date-fns/is_before';
import styles from './Header.scss';
import animation from './Animation.scss';
import WarningIcon from '@material-ui/icons/Warning';

export default function defaultSelectionRenderer(value, {
  display,
  key,
  locale: { locale },
  dateFormat,
  onYearClick,
  scrollToDate,
  setDisplay,
  shouldAnimate,
  minDate,
  maxDate
}) {
  const date = parse(value);
  const values = date && [
    {
      active: display === 'years',
      handleClick: e => {
        onYearClick(date, e, key);
        setDisplay('years');
      },
      item: 'year',
      title: display === 'days' ? `Change year` : null,
      value: date.getFullYear(),
    },
    {
      active: display === 'days',
      handleClick: () => {
        if (display !== 'days') {
          setDisplay('days');
        } else if (date) {
          scrollToDate(date, -40, true);
        }
      },
      item: 'day',
      title: display === 'days'
        ? `Scroll to ${format(date, dateFormat, { locale })}`
        : null,
      value: format(date, dateFormat, { locale }),
    },
  ];

  let showWarning = false;
  if (minDate !== null && maxDate !== null && (isBefore(date, minDate) || isAfter(date, maxDate))) {
    showWarning = true
  }
  return (
    <div
      key={key}
      className={styles.wrapper}
      aria-label={format(date, dateFormat + ' YYYY', { locale })}
    >
      {values.map(({ handleClick, item, key, value, active, title }) => {
        return (
          <div
            key={item}
            className={classNames(styles.dateWrapper, styles[item], {
              [styles.active]: active,
            })}
            title={title}
          >
            <CSSTransitionGroup
              transitionName={animation}
              transitionEnterTimeout={250}
              transitionLeaveTimeout={250}
              transitionEnter={shouldAnimate}
              transitionLeave={shouldAnimate}
            >
              <span
                key={`${item}-${value}`}
                className={styles.date}
                aria-hidden
                onClick={handleClick}
              >
                {value}{" "}
                {showWarning && item ==="day" && <WarningIcon />}
              </span>
            </CSSTransitionGroup>
          </div>
        );
      })}
    </div>
  );
}
